module.exports = __webpack_public_path__ + "static/img/far1_active.bf7a8aa4.png";